import React, { useState, useEffect, useContext } from "react";
import { Context } from "../../../redux/store";
import { Link } from "gatsby";
import ExternalLink from "../../external-link";
import { useSiteMetadata } from "../../../hooks/use-site-metadata";
import svgMoreMenu from "../../../images/more-menu.svg";

import navSchema from "./schema.json";
import NavBar from "../../nav-bar";

function Nav() {
  const { state, dispatch } = useContext(Context);
  const [triggerClose, setTriggerClose] = useState(false);
  const [currentActiveId, setCurrentActiveId] = useState(null);

  const { externalLinkInfo } = useSiteMetadata();
  const { dailymedLinkInfo } = useSiteMetadata();

  const closeHamburger = () => {
    setTriggerClose(Date.now());
  };
  const [mainNavs, setMainNavs] = useState([]);

  const getNavChildren = (_parentId) =>
    _parentId
      ? navSchema.filter((_navItem) => _navItem.parentId === _parentId)
      : [];

  const mobileNavClick = (_id) => {
    if (_id == currentActiveId) {
      setCurrentActiveId(null);
      return;
    }
    setCurrentActiveId(_id);
  };

  useEffect(() => {
    const parentNavs = [];

    navSchema.forEach((nav) => {
      if (nav.parentId === null) {
        parentNavs.push(nav);
      }
    });
    setMainNavs(parentNavs);
  }, []);

  useEffect(() => {
    console.log(state.isMobile);
  }, [state.isMobile]);

  return (
    <NavBar mobileBreakPoint={846} triggerHamburgerClose={triggerClose}>
      <nav>
        {!state.isMobile ? (
          <div className="navbar navbar-pat desktop">
            {mainNavs.map((navItem, index) => {
              return (
                <Link
                  to={navItem.url}
                  key={navItem.navId}
                  className={`nav-item parent-nav parent-nav-${index}`}
                  activeClassName="active"
                >
                  <span dangerouslySetInnerHTML={{ __html: navItem.title }} />
                </Link>

              );
            })}
          </div>
        ) : (
          <div className="navbar navbar-pat mobile">
            {mainNavs.map((navItem, index) => {
              return (
                <Link
                  to={navItem.url}
                  className="nav-item head-nav-item"
                  key={index}
                  onClick={closeHamburger}
                  activeClassName="active"
                  partiallyActive={true}
                >
                  <span dangerouslySetInnerHTML={{ __html: navItem.title }} />
                </Link>
              );
            })}

            <ExternalLink
              externalURL="https://dailymed.nlm.nih.gov/dailymed/fda/fdaDrugXsl.cfm?setid=b7d23ac2-e776-9f62-3290-c64c2d6eb353&type=display#section-17"
              messageTitle={dailymedLinkInfo.TITLE}
              messageBody={externalLinkInfo.BODY}
              classNameLink={externalLinkInfo.LINK_CLASS_NAME}
              classNameOverlay={externalLinkInfo.OVERLAY_CLASS_NAME}
            >
              <span className="caption">Medication Guide</span>
            </ExternalLink>

            <a
              href="https://www.purduepharma.com/healthcare-professionals/ask-purdue-medical/"
              target="_blank"
              className="nav-item head-nav-item other-nav"
            >
              <span className="caption">Report a Side Effect</span>
            </a>

            <a
              href="https://www.purduepharma.com/healthcare-professionals/ask-purdue-medical/"
              target="_blank"
              className="nav-item head-nav-item other-nav"
            >
              <span className="caption">Product Quality Complaint</span>
            </a>
            <Link
              to="/contact-us"
              className="nav-item head-nav-item other-nav"
              onClick={closeHamburger}
            >
              <span className="caption">Contact Us</span>
            </Link>
            <Link
              to="/terms-and-conditions"
              className="nav-item head-nav-item other-nav"
              onClick={closeHamburger}
            >
              <span className="caption">Terms of Use</span>
            </Link>
            <a
              href="https://www.purduepharma.com/about/ethics-and-compliance/ccpa/"
              target="_blank"
              className="nav-item head-nav-item other-nav"
            >
              <span className="caption">Privacy Policy</span>
            </a>
            <Link
              to="/site-map"
              className="nav-item head-nav-item other-nav"
              onClick={closeHamburger}
            >
              <span className="caption">Site Map</span>
            </Link>
          </div>
        )}
      </nav>
    </NavBar>
  );
}

export default Nav;
